import * as React from "preact";
import { FunctionComponent } from "preact";

export interface INoResults {
  text?: string;
  query?: string;
}

const NoResults: FunctionComponent<INoResults> = ({ text }) =>
  text ? (
    <div
      className="search-results__no-results"
      dangerouslySetInnerHTML={{ __html: text }}
    >
      {text}
    </div>
  ) : null;

export default NoResults;
